import { render } from "./BookingsManagement.vue?vue&type=template&id=61388342&scoped=true"
import script from "./BookingsManagement.vue?vue&type=script&lang=js"
export * from "./BookingsManagement.vue?vue&type=script&lang=js"

import "./BookingsManagement.vue?vue&type=style&index=0&id=61388342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61388342"]])

export default __exports__